module.exports = __webpack_public_path__ + "img/stl.f90d7a81.jpg";